<template>
	<div class="homeshake-listings py-5">
		<div class="heading text-center text-uppercase">
			<h2>Live in Cincinnati</h2>
		</div>
		<div class="glide my-5">
            <!-- Controls -->
            <div class="controls container-fluid px-lg-5">
                <div class="glide__navigation d-flex flex-nowrap justify-content-between align-items-center pr-lg-3">
                    
                    <a :href="moreHousingLink" class="text-mauve text-uppercase more-housing-link" target="_blank">View more housing</a>
                    <div class="glide__arrows d-flex flex-row justify-content-end mr-2" data-glide-el="controls">
                        <button
                            class="glide__arrow glide__arrow--left"
                            data-glide-dir="<"
                        >
                            <i class="icon left">
                                <svg width="24px" height="14px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="homepage" transform="translate(-639.000000, -1367.000000)" fill="#000000" fill-rule="nonzero">
                                            <g id="Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project" transform="translate(639.000000, 1367.000000)">
                                                <g id="Group" transform="translate(0.000000, 0.170825)">
                                                    <path d="M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z" id="Path"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </i>
                        </button>
                        <button
                            class="glide__arrow glide__arrow--right"
                            data-glide-dir=">"
                        >
                            <i class="icon right">
                                <svg width="24px" height="14px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <g id="homepage" transform="translate(-639.000000, -1367.000000)" fill="#000000" fill-rule="nonzero">
                                            <g id="Arrow-to-left-by-Icons-Bazaar-from-the-Noun-Project" transform="translate(639.000000, 1367.000000)">
                                                <g id="Group" transform="translate(0.000000, 0.170825)">
                                                    <path d="M6.92163043,0.088631687 C6.80272343,0.0992956367 6.6907857,0.149373042 6.60358696,0.230914296 L0.17576087,6.12308821 C0.0633038102,6.22465908 -0.000874988537,6.36910631 -0.000874988537,6.52064256 C-0.000874988537,6.6721788 0.0633038102,6.81662603 0.17576087,6.9181969 L6.60358696,12.8103708 C6.74547197,12.9399304 6.94582879,12.9836808 7.1288056,12.9250589 C7.31178241,12.8664371 7.44941382,12.7144024 7.48959483,12.5265127 C7.52977585,12.338623 7.46636537,12.1435947 7.32336957,12.0152621 L1.91663043,7.06047951 L23.0330435,7.06047951 C23.3160352,7.0644969 23.5770652,6.80783917 23.5770652,6.52482734 C23.5770652,6.24181551 23.3160352,5.98518456 23.0330435,5.98917517 L1.91663043,5.98917517 L7.32336957,1.02602299 C7.49879856,0.87327778 7.55561094,0.624778214 7.4639822,0.410977824 C7.37235346,0.197177434 7.15322455,0.0669384219 6.92163043,0.088631687 Z" id="Path"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </i>
                        </button>
                    </div>
                </div><!--/.glide__navigation-->
            </div>
			<!-- Carousel -->
			<div class="glide__track" data-glide-el="track">
				<ul class="glide__slides mb-md-0">
					<li
						class="glide__slide"
						v-for="property in useProperties"
						:key="property.title"
					>
                        <div class="slide-wrapper">
                            <div class="slide-image">
                                <img :src="property.imageUrl" :alt="property.address + ' Image'"/>
                            </div>
                            <div class="slide-content">
                                <div class="container-fluid px-lg-5">
                                    <div class="row">
                                        <div class="slide-details col-lg-6 pt-3">
                                            <img :src="property.imageUrl" alt="" class="slide-detail-image w-100 mb-4 d-lg-none">
                                            <h3 class="slide-title text-uppercase">{{ property.title }}</h3>
                                            <p class="slide-address text-uppercase">{{property.address}} - {{property.sqft}} SQFT.</p>
                                            <p class="slide-description full" v-if="property.story != ''">
                                                <!-- @todo truncate description content -->
                                                {{ property.story }}
                                            </p>
                                            <p class="slide-description truncated" v-if="property.story_truncated != ''">
                                                <!-- @todo truncate description content -->
                                                {{ property.story_truncated }}
                                            </p>
                                            <p class="slide-description mobile" v-if="property.story_truncated_mobile != ''">
                                                <!-- @todo truncate description content -->
                                                {{ property.story_truncated_mobile }}
                                            </p>
                                            <div class="slide-link-wrapper mt-auto mb-3">
                                                <a :href="property.link" target="_blank" class="slide-link btn btn-mauve">View Property</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
				</ul>
			</div>
            <!-- Thumbnails -->
            <div class="thumbnails container-fluid px-lg-5">
                <div class="glide__bullets d-flex flex-wrap" data-glide-el="controls[nav]">
                    <button
                        v-for="(property, index) in useProperties"
                        :key="property.address"
                        class="glide__bullet col-4 col-sm-4 col-md col-lg pl-0 pr-3"
                        :data-glide-dir="'=' + index"
                    >
                        <img :src="property.imageUrl" alt="Property Thumbnail" />
                    </button>
                </div>
            </div>
		</div>
	</div>
</template>
<style scoped lang="scss">
    @import '../../../node_modules/bootstrap/scss/_functions.scss';
    @import '../../../node_modules/bootstrap/scss/mixins.scss';
    @import '../../scss/config/bootstrap.scss';
	.homeshake-listings {
		background: white;
		color: black;
        .heading h2 {
            font-weight: bold;
        }
    }
    .more-housing-link {
        font-weight: bold;
    }
    .glide__navigation,
    .glide__bullets {
        width: 45%;
    }
    .glide {
        position: relative;
        .controls,
        .thumbnails {
            position: absolute;
            z-index: 2;
        }
        .controls {
            top: 0;
            left: 0;
        }
        .thumbnails {
            bottom: 0;
            left: 0;
        }
        // Sizing
        .controls {
            height: 50px;
        }
        .thumbnails {
            height: 120px;
        }
        .slide-content .row {
            height: calc(400px + 120px + 50px + 2rem);
            padding-top: calc(50px + 1rem);
        }

        @include media-breakpoint-down(md) {
            .controls,
            .thumbnails {
                padding: relative;
                height: auto;
                width: 100%;
            }
            .glide__navigation,
            .glide__bullets {
                width: 100%;
            }
            .slide-wrapper {
                .slide-image {
                    display: none;
                    // position: relative;
                    // left: auto;
                    // top: auto;
                    // bottom: auto;
                    // width: 100%;
                }
                .slide-content {
                    img {
                        width: 100%;
                        height: auto;
                    }
                    .row {
                        height: auto;
                        .slide-details {
                            height: auto;
                        }
                        padding-top: 1rem;
                    }
                }
            }
        }
    }
    .glide__slide,
    .slide-wrapper {
        width: 100vw !important;
        max-width: 100vw;
    }
    .glide__bullets {
        .glide__bullet {
            height: 120px;
            border: none;
            background-color: transparent;
            padding-right: .5rem;
            img {
                object-fit: cover;
                width: 100%;
                height: 100%;;
            }
        }
    }
    .slide-wrapper {
        position: relative;
        .slide-image {
            position: absolute;
            width: calc(55% - .25rem);
            left: calc(45% + .25rem);
            top: 0;
            bottom: 0;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                object-position: center center;
            }
        }
        .slide-content {
            position: relative;
            &:before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                width: calc(45% + .25rem);
                background: #fff;
            }
        }
        .slide-details {
            background-color: white;
            h3 {
                font-size: 30px;
                font-weight: bold;
            }
            p {
                font-size: 20px;
                max-height: 180px;
                overflow: hidden;
                text-overflow: ellipsis;
                @include media-breakpoint-down(lg) {
                    max-height: unset;
                }
            }

            .slide-description {
                &.full {
                    display: none;
                }            
                &.truncated {
                    display: block;
                }
                &.mobile {
                    display: none;
                }
            }
            
            @include media-breakpoint-down(lg) {
                .slide-description {            
                    &.full {
                        display: none;
                    }     
                    &.truncated {
                        display: none;
                    }       
                    &.mobile {
                        display: block;
                    }
                }
                
            }      
            @include media-breakpoint-down(md) {
                .slide-description {
                    &.full {
                        display: block;
                    }     
                    &.truncated {
                        display: none;
                    }       
                    &.mobile {
                        display: none;
                    }
                }
            }

           
            
            @include media-breakpoint-up(md) {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
           
        }
    }
    .glide__arrows {
        .glide__arrow {
            background-color: transparent;
            border: none;
            padding: 0;
            font-size: 0;
            height: auto;
            width: auto;
            .icon {
                svg {
                    height: 1rem;
                }
            }
            &.glide__arrow--right {
                margin-left: 1rem;
                svg {
                    transform: rotateZ(180deg);
                }
            }
        }
    }


    @include media-breakpoint-down(lg) {
        .glide {
            .thumbnails {
                position: initial;
                bottom: initial;
                left: initial;
                margin-top: 15px;
                .glide__bullets {
                    width: 100%;
                }
            }
        }
    }

    @include media-breakpoint-down(sm) {
        .glide {
            .thumbnails {
                .glide__bullets {
                    width: 100%;
                }
            }
        }
    }
	
</style>
<script>
    const API_URL = '/wp-json/api/listings';
    // {
    //     address: string;
    //     description: string;
    //     imageUrl: string;
    //     link: string;
    //     sqft: string;
    //     story: string;
    // }
    import { shuffle } from 'lodash';
	import Glide from '@glidejs/glide';
	export default {
        props: ['housingLink', 'showAtMost'],
		data() {
			return {
                listings: [],
                options: {
                    type: 'carousel',
                    perView: 1,
                    startAt: 0,
                },
                slider: null,
            };
		},
		computed: {
            moreHousingLink() {
                return this.housingLink || '/housing';
            },
			useProperties() {
				// Only use the first four properties per design
                this.listings = this.listings.map((list) => {
                    return {...list, story_truncated: (list.story.substr(0, list.story.lastIndexOf(' ', 300))) + "...", story_truncated_mobile: (list.story.substr(0, list.story.lastIndexOf(' ', 150))) + "..."}
                });
				return shuffle( this.listings ).slice( 0, this.showAtMost || 4 );
            }
        },
        methods: {
            mountSlider() {
                const sliderElement = this.$el.querySelector('.glide');
                if (sliderElement) {
                    const slider = new Glide(sliderElement, {
                        type: 'slider',
                        perView: 1,
                        startAt: 0,
                        gap: 0
                    });
                    try {
                        slider.mount();
                    } catch (error) {
                        console.error('Error Mounting Slider', error);
                    }
                } else {
                    console.log('No element');
                }
            }
        },
        created() {},
		mounted() {
            //call API to get home data...
            this.axios.get(API_URL).then((res) => {
                const listings = res.data;
                this.listings = listings;
                setTimeout(() => {
                    this.mountSlider();
                });
            });
        }
	};
</script>
